import "./tarifsDefault.css";

function TarifsDefault() {
  return (
    <div className="tarifs-default">
      <p className="tarifs-default__text">
        Si vous voyez ce texte, merci de contacter le responsable du site web.
      </p>
    </div>
  );
}

export default TarifsDefault;
